import { styled } from 'styled-components';

export const HeaderContainer = styled.div<{ $denseFormat?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  margin: ${({ theme, $denseFormat }) =>
    $denseFormat
      ? `0 ${theme.spacing(1.5)} 0 ${theme.spacing(3.5)}`
      : `${theme.spacing(2.5)} ${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(3.5)}`};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};

  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};

  color: ${({ theme }) => theme.palette.text.primary};
`;
